import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { LabelS } from 'atoms/typography';

const Counter = styled(LabelS)`
  display: inline-flex;
  align-items: center;
  gap: var(--half-unit);
`;

type Props = {
  count: number;
  limit: number;
};

export const ItemCounter = ({ count, limit }: Props) => (
  <Counter color="var(--c-white)">
    <FormattedMessage
      id="ShopItemPicker.Item.Counter"
      defaultMessage="{myPurchasesCount} / {limitPerUser}"
      values={{
        myPurchasesCount: count,
        limitPerUser: limit,
      }}
    />
  </Counter>
);
